import React from 'react';
import { useTranslation } from 'react-i18next';
// core
import { TextField } from '@material-ui/core';

import { EDIT_MODE, VIEW_MODE } from '../../../utils/const/taskModes';

import useStyles from '../styles';
import QuestionShell from '../QuestionShell';
import useQuestionForm from '../QuestionShell/useQuestionForm';

function FormattedAnswer({
  identifier, pages, info,
  mode, handleDeleteQuestion, handleDuplicateQuestion, setPages,
}) {
  const styles = useStyles();
  const { t } = useTranslation();

  const question = useQuestionForm({
    identifier, pages, info, setPages, writeVia: 'setPages',
  });

  return (
    <QuestionShell
      {...question}
      identifier={identifier}
      info={info}
      mode={mode}
      titleKey="task.taskEdition.formattedAnswerText.question"
      descriptionKey="task.taskEdition.shortAnswerText.description"
      handleDeleteQuestion={handleDeleteQuestion}
      handleDuplicateQuestion={handleDuplicateQuestion}
    >
      <TextField
        id="format"
        className={styles.question}
        label={t('task.taskEdition.formattedAnswerText.format')}
        placeholder={t('task.taskEdition.formattedAnswerText.format')}
        value={info ? info.format : pages[identifier - 1].format}
        InputProps={{ disableUnderline: true }}
        inputProps={{ maxLength: 250 }}
        onChange={mode === EDIT_MODE ? question.handleOnChange : null}
        disabled={mode === VIEW_MODE}
      />
      <TextField
        id="formatDescription"
        className={styles.question}
        label={t('task.taskEdition.formattedAnswerText.formatDescription')}
        placeholder={t('task.taskEdition.formattedAnswerText.formatDescription')}
        value={info ? info.formatDescription : pages[identifier - 1].formatDescription}
        InputProps={{ disableUnderline: true }}
        inputProps={{ maxLength: 250 }}
        onChange={mode === EDIT_MODE ? question.handleOnChange : null}
        disabled={mode === VIEW_MODE}
      />
    </QuestionShell>
  );
}

export default FormattedAnswer;
